<!--
 * @Author: ymk
 * @Date: 2020-07-28 15:28:33
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 19:24:10
 * @FilePath: \car-demo\src\views\Ranking\Customer.vue
-->
<template>
  <div class="customer">
    <FixedTool/>
    <nut-scroller
        class="wrapper"
        :is-un-more="isUnMore"
        :is-loading="isLoading"
        :type="'vertical'"
        :unloadMoreTxt="'没有更多了'"
        @loadMore="loadMoreVert"
        @pulldown="pulldown"
    >
      <div slot="list" class="nut-vert-list-panel">
        <div v-if="listData && listData.length">
          <div class="wrapper-item" v-for="(item, index) in listData" :key="index">
            <div class="golden-customer">
              <div class="icon">
                <img v-if="index <= 2" :src="require(`@/assets/images/huiyuan-${index}.png`)" alt="">
                <span v-else>{{ index }}</span>
              </div>
              <nut-avatar bg-icon size="large" class="avatar" :bg-image="item.head_pic"></nut-avatar>
              <ul>
                <li class="name">{{ item.nickname }}</li>
                <li class="desc">已送出{{ item.num }}个礼物</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <empty v-else></empty> -->
      </div>
    </nut-scroller>
  </div>
</template>

<script>
import empty from '../Empty'

export default {
  name: 'customer',
  components: {empty},
  data: () => ({
    listData: [],
    isUnMore: false,
    isLoading: false,
    page: 1,
    pageSize: 15,//首次15条,以后每次10条
  }),
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$ajax.get('m/gift/gift_ranking_by_user', {
        activity_id: this.$ajax.get_activity_id(),
        page_size: this.pageSize,
        page: this.page
      }).then(res => {
        if (res.length > 0 || this.listData.length > 0) {
          this.listData = this.listData.concat(res);
        } else {
          this.listData = [];
        }
        if (res.length < this.pageSize) {
          this.isUnMore = true;
        }
        this.isLoading = false;
        this.pageSize = 10;
      })
    },
    // 下拉加载更多
    pulldown() {
      this.isLoading = true
      this.isUnMore = false;
      this.pageSize = 15;
      this.page = 1;
      this.listData = [];
      this.getList();
    },
    // 上拉加载更多
    loadMoreVert() {
      this.isLoading = true;
      this.getList();
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  width: 90vw;
  height: 90vh;
  padding: 14px;

  &-item {
    margin-bottom: 10px;
  }
}

.golden-customer {
  display: flex;
  // align-items: center;
  margin-bottom: 10px;

  ul {
    box-sizing: border-box;
    flex-grow: 1;
    border-bottom: 1px solid #E2E2E2;
    padding-bottom: 10px;
  }

  .icon {
    width: 20px;
    height: 16px;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-top: 14px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .avatar {
    width: 44px;
    height: 44px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .name {
    color: #333333;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .desc {
    color: #666666;
    font-size: 13px;
  }
}
</style>
